import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b00c3cee"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.29._a7b6b2d0a8f0803019d019baabfbdad7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports